/* WHITE NOVEMBER ‚Äî ask about this piece (item 156, from audit item 10).

   Bianca, after testing the first build: "I've clicked on inquire about this
   piece, and it's taken me to start your bespoke inquiry. That's completely
   wrong... you click it, and then it drops down a ask a question, add your
   email in, and your name, and then it just sends straight to us."

   THIS SCRIPT DOES NOT DELIVER THE QUESTION. Shopify's own contact form
   does, by being submitted normally, which is the whole reason it is a real
   form: this store has invisible captcha on contact forms, and a scripted
   POST to /contact is answered 400 every time (measured on the draft, 8
   Sept). So the browser submits, Shopify emails the studio, and the page
   comes back with contact_posted=true. All this file does is open and close
   the box, attach what the customer was looking at, and write the same
   question to Klaviyo on the way out.

   THE BEACONS SURVIVE THE NAVIGATION because of keepalive, and because the
   submit is never cancelled. Holding the submit and re-firing it with
   form.submit() would skip the listener Shopify's captcha script binds, and
   put us straight back at 400 ‚Äî so the handler fires and returns, and the
   browser carries on.

   LEAD, SINCE 19 OCT 2026. The first build fired only the custom
   ProductQuestion event, on the reasoning that a question about a
   ready-to-ship ring should not steer an ad set optimising for bespoke
   commissions. Bianca overruled that after a $19,585 Bauhaus Trilogy
   question arrived by this form on 13 Oct and Meta could not count it: a
   question about a specific ring IS a lead. So Lead now fires as well, with
   content_category "Product question" so it stays separable from the
   bespoke form's Lead in reporting. ProductQuestion is kept for the
   history it already has. */
(function () {
  'use strict';

  var COMPANY_ID = 'Uc4DZa';
  var REVISION = '2024-10-15';
  var METRIC_CUSTOMER = 'Product Question Asked';
  var METRIC_ALERT = 'Product Question Alert';
  var ALERT_TO = 'info@whitenovember.com.au';
  var ECHO_KEY = 'wn-ask-echo';

  var box = document.querySelector('[data-wn-ask]');
  if (!box) return;

  var form = box.querySelector('form');
  var qField = box.querySelector('[data-wn-ask-question]');
  var eField = box.querySelector('[data-wn-ask-email]');
  var fField = box.querySelector('[data-wn-ask-first]');
  var variantField = box.querySelector('[data-wn-ask-variant-field]');
  var priceField = box.querySelector('[data-wn-ask-price-field]');
  var echo = box.querySelector('[data-wn-ask-echo]');

  var TITLE = box.getAttribute('data-product-title') || '';
  var URL_ = box.getAttribute('data-product-url') || window.location.href;
  var PID = box.getAttribute('data-product-id') || '';

  function trim(v) { return String(v == null ? '' : v).trim(); }
  function triggers() { return document.querySelectorAll('[data-wn-ask-open]'); }

  /* WHAT THEY WERE LOOKING AT, read when the box opens rather than when the
     page renders, because the metal swatch and the size dropdown change
     after load. The variant id is the one the add-to-cart form would
     actually submit, so the answer describes the same ring the customer had
     in front of them. */
  function currentVariant() {
    try {
      var idEl = document.querySelector('[data-wn-variant-id]');
      var dataEl = document.querySelector('[data-wn-variant-data]');
      if (!idEl || !dataEl) return '';
      var want = String(idEl.value || '');
      var list = (JSON.parse(dataEl.textContent || '{}') || {}).variants || [];
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === want) return (list[i].options || []).join(', ');
      }
    } catch (e) {}
    return '';
  }

  function currentPrice() {
    try {
      var el = document.querySelector('.wn-pdp__price[data-wn-price]') || document.querySelector('[data-wn-price]');
      if (!el) return box.getAttribute('data-product-price') || '';
      /* The compare-at price is a child <s>; the live price is this node's
         own text, so read the text nodes rather than textContent. */
      var txt = '';
      for (var i = 0; i < el.childNodes.length; i++) {
        if (el.childNodes[i].nodeType === 3) txt += el.childNodes[i].nodeValue;
      }
      return trim(txt) || trim(el.textContent);
    } catch (e) {}
    return box.getAttribute('data-product-price') || '';
  }

  function stamp() {
    var vs = currentVariant();
    if (variantField) variantField.value = vs;
    if (priceField) priceField.value = currentPrice();
  }

  function setExpanded(state) {
    var t = triggers();
    for (var i = 0; i < t.length; i++) t[i].setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  function open(moveFocus) {
    box.hidden = false;
    setExpanded(true);
    stamp();
    if (moveFocus && qField) {
      try { qField.focus({ preventScroll: true }); } catch (e) { try { qField.focus(); } catch (e2) {} }
    }
    /* Only scroll if the box has opened off the bottom of the window. On a
       desktop the buy box is usually fully in view already and moving the
       page under someone who just clicked a button is its own small insult. */
    try {
      var r = box.getBoundingClientRect();
      if (r.bottom > window.innerHeight) box.scrollIntoView({ behavior: 'smooth', block: 'end' });
    } catch (e) {}
  }

  function close(moveFocus) {
    box.hidden = true;
    setExpanded(false);
    if (moveFocus) {
      var t = triggers();
      if (t.length) { try { t[0].focus(); } catch (e) {} }
    }
  }

  function eventId() {
    try {
      if (window.crypto && crypto.randomUUID) return 'wn-ask-' + crypto.randomUUID();
    } catch (e) {}
    return 'wn-ask-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function sendEvent(metric, profileAttrs, props) {
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID, {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: props,
              metric: { data: { type: 'metric', attributes: { name: metric } } },
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            }
          }
        })
      });
    } catch (e) {}
  }

  function sendMeta(props) {
    try {
      if (typeof window.fbq !== 'function') return;
      var m = {};
      if (props['Email']) m.em = String(props['Email']).toLowerCase();
      if (props['First name']) m.fn = String(props['First name']).toLowerCase();
      var has = false;
      for (var k in m) { if (Object.prototype.hasOwnProperty.call(m, k)) has = true; }
      if (has && window.fbq.getState) {
        var st = window.fbq.getState();
        var pid = st && st.pixels && st.pixels.length ? st.pixels[0].id : '152810061798202';
        window.fbq('init', pid, m);
      }
      window.fbq('trackCustom', 'ProductQuestion', {
        content_name: props['Piece'] || '',
        content_ids: PID ? [PID] : undefined,
        content_type: 'product'
      }, { eventID: props['Meta event id'] });
      /* Lead as well (19 Oct 2026, see the header). Own event id so a
         server-side replay could dedupe it separately from ProductQuestion. */
      window.fbq('track', 'Lead', {
        content_name: props['Piece'] || '',
        content_category: 'Product question',
        content_ids: PID ? [PID] : undefined,
        content_type: 'product'
      }, { eventID: props['Meta event id'] + '-lead' });
    } catch (e) {}
  }

  if (form && qField && eField) {
    form.addEventListener('submit', function () {
      /* Native validation has already passed by the time this runs, and the
         event is deliberately not cancelled: Shopify's captcha script is
         listening on this same submit. */
      var props = {
        'Question': trim(qField.value),
        'Piece': TITLE,
        'Variant': currentVariant(),
        'Price': currentPrice(),
        'Product link': URL_,
        'First name': fField ? trim(fField.value) : '',
        'Email': trim(eField.value),
        'Page': window.location.pathname,
        'Meta event id': eventId()
      };
      if (!props['Question'] || !props['Email']) return;

      try { sessionStorage.setItem(ECHO_KEY, props['Question']); } catch (e) {}

      /* Identify to the onsite script so this lands on the profile the rest
         of the site already tracks, as the enquiry and the servicing form
         do. Never klaviyo.identify for the studio address: the onsite object
         holds one active profile per browser, so the alert would overwrite
         the visitor's own identity. */
      try {
        var who = { $email: props['Email'] };
        if (props['First name']) who.$first_name = props['First name'];
        var k = window.klaviyo;
        if (k && typeof k.identify === 'function') k.identify(who);
        else { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', who]); }
      } catch (e) {}

      sendEvent(METRIC_CUSTOMER, { email: props['Email'], first_name: props['First name'] || undefined }, props);
      sendEvent(METRIC_ALERT, { email: ALERT_TO }, props);
      sendMeta(props);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-wn-ask-open]')) {
      e.preventDefault();
      if (box.hidden) open(true); else close(true);
      return;
    }
    if (t.closest('[data-wn-ask-close]')) { e.preventDefault(); close(true); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) close(true);
  });

  /* Coming back from Shopify's redirect: reopen the box on the thank-you and
     hand the customer their own question back, so the reload does not read
     as though it was lost. Also opens for anything linking to #ask. */
  var posted = window.location.search.indexOf('contact_posted=true') !== -1;
  if (posted && echo) {
    try {
      var saved = sessionStorage.getItem(ECHO_KEY);
      if (saved) { echo.textContent = saved; echo.hidden = false; sessionStorage.removeItem(ECHO_KEY); }
    } catch (e) {}
  }
  if (posted || window.location.hash === '#ask') {
    open(false);
    try { box.scrollIntoView({ block: 'center' }); } catch (e) {}
  }
})();
